if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    const currentUrl = window.location.href
    if( currentUrl.indexOf( "#" ) != "-1" ){

        let hash = currentUrl.split("#")[1]
        let element = document.querySelector( "[data-tag="+hash+"]" )
        if( element ){
            setTimeout( () => { 
                element.click(); 
                let pos1 = element.offsetTop; 
                window.scroll({
                    top: pos1 - 500,
                    behavior: 'smooth'
                  });
            }, 1000 )
        }
    }

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: false
    });

    //Footer Email Signup 
    const signupTrigger = document.getElementById("js-signup-trigger");

    signupTrigger.addEventListener("click", () => {
        document.getElementById("signup-full").classList.add("open");
        signupTrigger.classList.add('hide');
    });
    
    const animateHTML = function () {
        let elems,
            elemsShow,
            windowHeight;
        let init = function () {
            elems = document.getElementsByClassName('hide-object');
            elemsShow = document.getElementsByClassName('show-object');
            windowHeight = window.innerHeight;
            addEventHandlers();
        }; 
        let addEventHandlers = function () {
            window.addEventListener('scroll', checkPosition);
            window.addEventListener('resize', init);
        };
        let checkPosition = function () {
            for (let i = 0; i < elems.length; i++) {
                let posFromTop = elems[i].getBoundingClientRect().top;
                if (posFromTop - windowHeight <= 0) {
                    elems[i].className = elems[i].className.replace('hide-object', 'show-object')
                }
            } 
            for (let i = 0; i < elemsShow.length; i++) {
                let posFromTop = elemsShow[i].getBoundingClientRect().top;
                if (posFromTop - windowHeight >= 0) {
                    elemsShow[i].className = elemsShow[i].className.replace('show-object', 'hide-object')
                } 
            } 
        };
        return {
            init: init 
        }
    };
    animateHTML().init();
    function isSafari() {
        var ua = navigator.userAgent.toLowerCase(); 
		return ua.indexOf('safari') != -1 && ua.indexOf('chrome') == -1 && ua.indexOf('android') == -1;
    }

    if (!isSafari()) {
        document.querySelectorAll('.title.with-script span').forEach(element => {
            let singleLetters = element.textContent.split('');
            singleLetters = singleLetters.map(letter => `<i>${letter}</i>`).join('');
            element.innerHTML = singleLetters;
        })
        
    }

    document.addEventListener('DOMContentLoaded', (event) => {

        let rfp_venues = document.querySelector('#form_id-262'),
            rfp_contact = document.querySelector('#form_id-263'),
            rfp_log_your_bookings = document.querySelector('#form_id-261');
        if(rfp_venues){
            rfp_venues.addEventListener( 'submit', () => {
                let current_value_interest = document.querySelector( '[name="type_of_group"]' ).value;
                if(IS_LIVE  && typeof dataLayer != 'undefined' && typeof dataLayer.push != 'undefined') {
                    dataLayer.push({'vertical': current_value_interest});
                }
            } )
        }else if(rfp_contact){
            rfp_contact.addEventListener( 'submit', () => {
                let current_value_department = document.querySelector( '[name="department"]' ).value;
                if(current_value_department == 'cruise_department'){
                    current_value_department = 'cruise';
                }
                if(IS_LIVE  && typeof dataLayer != 'undefined' && typeof dataLayer.push != 'undefined') {
                    dataLayer.push({'vertical': current_value_department});
                }
            } )
        }else if(rfp_log_your_bookings){
            rfp_contact.addEventListener( 'submit', () => {
                if(IS_LIVE  && typeof dataLayer != 'undefined' && typeof dataLayer.push != 'undefined') {
                    dataLayer.push({'vertical': 'Log your booking'});
                }
            } )
        }

        let cards_content = document.querySelector('.cards_content');
        if(cards_content){
            let anchors = cards_content.querySelectorAll(".item a");
            anchors.forEach(a => {
                a.addEventListener( 'click', () => {
                    let title_value = a.parentElement.querySelector('.title').textContent.replaceAll(' ', '_');
                    window.dataLayer = [];
                    window.dataLayer.push({
                        'vertical': title_value
                    })
                } )
            });
        }
    });

})();

/** ADA Tab Links Functionality for Keyboard Navigation in Menu **/

function updateMenuTabIndex() {
    const menu = document.querySelector('#main-menu');
    const isMenuVisible = menu && menu.classList.contains('open');
    const elements = document.querySelectorAll('.privary-navigation__item a, .secondary-navigation__item a');
    
    elements.forEach(element => {
        element.setAttribute('tabindex', isMenuVisible ? '0' : '-1');
    });
}

document.addEventListener('DOMContentLoaded', () => {
    updateMenuTabIndex();

    document.addEventListener('focusin', updateMenuTabIndex);
    const menu = document.querySelector('#main-menu');
    if (menu) {
        menu.addEventListener('transitionend', updateMenuTabIndex);
    }
});
